export default "__VITE_ASSET__DIMYGFnl__ 500w";